import { ThoughtOfTheDay } from './thought-of-the-day.model';
import { ApiErrorCode } from '../service-proxies';


export class ThoughtOfTheDayApiResponse implements IThoughtOfTheDayApiResponse {
    isSuccess!: boolean;
    responseData!: ThoughtOfTheDay;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IThoughtOfTheDayApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.responseData = _data["responseData"] ? ThoughtOfTheDay.fromJS(_data["responseData"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): ThoughtOfTheDayApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ThoughtOfTheDayApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IThoughtOfTheDayApiResponse {
    isSuccess: boolean;
    responseData: ThoughtOfTheDay;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

